export const MYSESSION_ENDPOINTS = {
  getMySessionList: "/session/subscribe"
} as const

export const MYSESSION_KEYS = {
  all: ["mySession"],
  mySessionList: () => [...MYSESSION_KEYS.all, "mySessionList"] as const
} as const
